import classNames from "classnames";
import {FiInfo} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {StatusPage, StatusPageTheme} from "@/lib/types/statuspages.ts";

import styles from "./InspireThemeBanner.module.scss";

const SUPPORT_URL = "https://support.uptime.com/hc/en-us/requests/new";

interface InspireThemeBannerProps {
  statusPage: StatusPage;
  // Form tabs (General, Design) zero out the tab content's horizontal margins, so the
  // banner needs its own inset there to line up with the non-form tabs' left content edge.
  formTab: boolean;
  // Live page URL, used once the page is served by the SPA so the link lands on the real page
  // rather than the in-app preview route.
  liveUrl: string;
}

export const InspireThemeBanner = ({statusPage, formTab, liveUrl}: InspireThemeBannerProps) => {
  if (statusPage.theme !== StatusPageTheme.INSPIRE) {
    return null;
  }

  return (
    <Alert variant={"maintenance"} icon={FiInfo} className={classNames(styles.banner, {[styles.inset]: formTab})}>
      {statusPage.is_served_by_spa ? (
        <>
          Your Status Page has been updated to a refreshed look — take a moment to{" "}
          <a href={liveUrl} className={styles.link} target={"_blank"} rel={"noopener noreferrer"}>
            view your updated Status Page
          </a>
          .
        </>
      ) : (
        <>
          We're updating the Inspire theme — your Status Pages will soon have a refreshed look. Please take a moment to{" "}
          <a
            href={`/status-page/private/${statusPage.id}`}
            className={styles.link}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            preview your updated Status Page
          </a>
          .
        </>
      )}{" "}
      <a href={SUPPORT_URL} className={styles.link} target={"_blank"} rel={"noopener noreferrer"}>
        Reach out to support
      </a>{" "}
      with any questions or concerns.
    </Alert>
  );
};
